import { Button, EmptyState } from '@zafroi/ui-kit';
import { Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon={Compass}
      title="We couldn't find that page"
      description="The URL doesn't match anything in ZAFROI Kosh. Try the dashboard."
      action={
        <Button size="sm" onClick={() => navigate('/dashboard')}>
          Go to dashboard
        </Button>
      }
    />
  );
}
